<template>
  <b-container class="container-rda">
    <b-row class="enrollment">
      <b-col>
        <h2 class="purple bold">Matrículas</h2>
      </b-col>
    </b-row>

    <b-container fluid v-if="studentsAnotherResponsible.length">
      <b-alert show variant="warning">
        <b>Atenção!</b>
        <ul class="mb-0">
          <li v-for="student in studentsAnotherResponsible" :key="student.name">
            A matrícula do(a) estudante
            <b>{{ student.name }}</b> foi feita pelo(a) usuário(a)
            <b>{{ student.responsibleName }}</b> com o login: "<b>{{
              student.email
              }}</b>".
          </li>
        </ul>
      </b-alert>
    </b-container>

    <b-container fluid>
      <b-row v-if="loading">
        <LoadingList v-model="loading" text="Carregando lista" :center="true" />
      </b-row>
      <b-row class="header-list-teacher" v-if="enrollments && enrollments.length >= 1 && !loading">
        <b-col md="1">
          <p class="bold">Matrícula</p>
        </b-col>
        <b-col md="2">
          <p class="bold">Aluno</p>
        </b-col>
        <b-col md="2">
          <p class="bold">Contratante</p>
        </b-col>
        <b-col md="3">
          <p class="bold">Preenchido</p>
        </b-col>
        <b-col md="1">
          <p class="bold">Ano</p>
        </b-col>
      </b-row>

      <div v-if="!this.loading">
        <b-row v-for="enroll in enrollments" :key="enroll.id" align-v="center" class="list-teacher">
          <b-col md="1">
            <p>#{{ enroll.id }}</p>
          </b-col>

          <b-col md="2">
            <p v-if="enroll.EnrollmentStudent">
              {{ enroll.EnrollmentStudent.name }}
            </p>
          </b-col>

          <b-col md="2">
            <p v-if="enroll.EnrollmentResponsibles.length">
              {{ getContractor(enroll.EnrollmentResponsibles).name }}
            </p>
          </b-col>

          <b-col md="3" v-if="enroll.WaitingList && enroll.WaitingList.blocked">
            <span class="waiting-list-tag" :class="{ 'waiting-list-tag--waiting': enroll.WaitingList.status === waitingListStatuses.WAITING }">{{ waitingListStatusLabel(enroll.WaitingList.status) }}</span>
          </b-col>

          <b-col md="3" class="progress-enrollment" :title="enroll.EnrollmentStudent.is_re_enroll === true
            ? 'Rematrícula'
            : ''
            " v-else-if="
              enroll.Calendar.designation === nextYear &&
              enroll.EnrollmentStudent != null &&
              enroll.EnrollmentStudent.is_re_enroll === true
            ">
            <p>{{ enroll.percentage }}%</p>
            <b-progress :value="enroll.percentage" max="100"></b-progress>
          </b-col>

          <b-col v-else md="3" class="progress-enrollment">
            <p>{{ enroll.percentage }}%</p>
            <b-progress :value="enroll.percentage" max="100"></b-progress>
          </b-col>

          <b-col md="1">
            <p>{{ enroll.Calendar.designation }}</p>
          </b-col>

          <b-col md="2" class="waiting-list-actions" v-if="enroll.WaitingList && enroll.WaitingList.blocked">
            <router-link :to="{
              name: enroll.EnrollmentStudent && enroll.EnrollmentStudent.is_re_enroll ? 'rematricula' : 'continuar-matricula',
              params: {
                id: enroll.id,
                edit: 'true',
                step: 'dados-do-aluno',
              },
            }" class="btn-link">Dados do aluno</router-link>
          </b-col>

          <b-col md="2" v-else-if="
            ((enroll.EnrollmentStudent &&
              enroll.EnrollmentStudent.is_re_enroll == true) ||
              (enroll.EnrollmentStep &&
                enroll.EnrollmentStep.enrollment_student === true)) &&
            enroll.percentage < 100 &&
            enroll.EnrollmentDefaulters === null
          ">
            <router-link v-if="enroll.EnrollmentStudent != null" :to="{
              name: 'rematricula',
              params: {
                id: enroll.id,
                step: defineStepByPercentage(enroll.percentage),
              },
            }" class="btn-link">Continuar Rematrícula</router-link>
          </b-col>

          <b-col md="2" v-else-if="
            enroll.percentage == 100 &&
            enroll.EnrollmentStudent != null &&
            +enroll.Calendar.designation < +enrollmentCalendar.designation &&
            enroll.EnrollmentDefaulters === null
          ">
            <span @click="
              rematricularAluno(
                enroll.EnrollmentStudent.id,
                enroll.id,
                enrollmentCalendar
              )
              " class="btn-rematricula pointer">Rematrícula {{ enrollmentCalendar.designation }}</span>
          </b-col>

          <b-col md="2" v-else-if="enroll.EnrollmentDefaulters === null && !hasDefaulter">
            <router-link v-if="enroll.percentage < 100" :to="{
              name: 'continuar-matricula',
              params: {
                id: enroll.id,
                edit: 'true',
                step: defineStepByPercentage(enroll.percentage),
              },
            }" class="btn-link">
              Continuar Matrícula
            </router-link>
          </b-col>

          <b-col md="2" v-else-if="enroll.EnrollmentDefaulters !== null">
            <p class="defautersText" style="font-size: 14px">
              Matricula Indisponível. Por favor, entrar em contato com
              financeiro.
            </p>
          </b-col>

          <b-col md="1" class="text-center" v-if="enroll.canDelete && enroll.percentage <= 70">
            <span @click="deleteEnroll(enroll.id)" class="pointer">
              <DeleteIcon class="deleteIcone" />
            </span>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-row class="enrollments-boxes">
      <b-col md="6" v-if="previousEnrollmentCalendar">
        <div class="box">
          <h3 class="mt-4 purple">Matrícula {{ previousEnrollmentCalendar.designation }}</h3>
          <p class="text">
            Clique para iniciar uma nova matrícula para o ano de
            {{ previousEnrollmentCalendar.designation }}.
          </p>

          <a href="#" v-if="!hasDefaulter" @click="createEnrollment(previousEnrollmentCalendar.id)" class="btn large" :class="{
            outline: previousEnrollmentCalendar.designation == currentYear,
            blue: previousEnrollmentCalendar.designation != currentYear,
          }" style="width: 220px">
            {{
              enrollments.filter((e) => e.calendar_id === previousEnrollmentCalendar.id).length
                ? `Adicionar novo aluno`
                : `Criar matrícula ${previousEnrollmentCalendar.designation}`
            }}
          </a>
          <p class="defautersText" v-else>
            Não é possível iniciar novas matrículas. Favor entrar em contato com
            o setor financeiro para maiores informações.
          </p>
        </div>
      </b-col>

      <b-col :md="previousEnrollmentCalendar ? '6' : '4'" v-if="enrollmentCalendar">
        <div class="box">
          <h3 class="mt-4 purple">Matrícula {{ enrollmentCalendar.designation }}</h3>
          <p class="text" v-if="enrollmentCalendar">
            Clique para iniciar uma nova matrícula para o ano de
            {{ enrollmentCalendar.designation }}.
          </p>

          <a href="#" v-if="!hasDefaulter" @click="createEnrollment(enrollmentCalendar.id)" class="btn large" :class="{
            outline: enrollmentCalendar.designation == currentYear,
            blue: enrollmentCalendar.designation != currentYear,
          }" style="width: 220px">
            {{
              enrollments.filter((e) => e.calendar_id === enrollmentCalendar.id).length
                ? `Adicionar novo aluno`
                : `Criar matrícula ${enrollmentCalendar.designation}`
            }}
          </a>
          <p class="defautersText" v-else>
            Não é possível iniciar novas matrículas. Favor entrar em contato com
            o setor financeiro para maiores informações.
          </p>
        </div>
      </b-col>
    </b-row>

    <b-row class="documents" style="padding-bottom: 25px;">
      <b-col>
        <div class="box-info">
          <div class="title">
            <h2>Documentos necessários para a matrícula:</h2>
          </div>

          <div class="content">
            <b-row>
              <b-col>
                <p class="bold">Matrícula de NOVO aluno:</p>
                <ul>
                  <li>
                    Fotos atualizadas do aluno, contratantes e pessoas
                    autorizadas a buscar o aluno;
                  </li>
                  <li>
                    Carteira de Identidade ou Certidão de Nascimento e CPF do
                    aluno;
                  </li>
                  <li>Carteira de Identidade e CPF dos dois Contratantes;</li>
                  <li>Cartão de Vacinas do aluno atualizado;</li>
                  <li>Comprovante de endereço atualizado;</li>
                  <li>Declaração de Transferência;</li>
                  <li>Declaração de Quitação emitida pela escola anterior;</li>
                  <li>
                    Histórico Escolar ou Registro de Percurso da Ed. Infantil (a
                    ser entregue em até 30 dias após a data da matrícula);
                  </li>
                  <li>
                    Contrato de Prestação de Serviços Educacionais (gerado ao final desse processo) assinado
                    digitalmente pelos dois Contratantes.
                  </li>
                </ul>
              </b-col>
              <b-col>
                <p class="bold">Rematrícula de alunos:</p>
                <ul>
                  <li>Foto atualizada do aluno;</li>
                  <li>Cartão de Vacina do aluno atualizado;</li>
                  <li>Comprovante de endereço atualizado;</li>
                  <li>
                    Será necessário o envio de documentos que tenham sido
                    alterados (ex.: CPF se houve mudança de nome ou de
                    contratante);
                  </li>
                  <li>
                    Contrato de Prestação de Serviços Educacionais (gerado ao final desse processo) assinado
                    digitalmente pelos dois Contratantes.
                  </li>
                </ul>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="enrollment" style="padding-top: 5px; padding-bottom: 25px;">
      <b-col>
        <h2 class="purple bold">Valores da matrícula</h2>
      </b-col>
    </b-row>

    <b-tabs content-class="mt-3" class="enrollment-price-tabs">
      <b-tab v-if="previousYear" :title="`${previousYear}`">
        <ResponsiblePriceView
          :prices="previousPrices"
          :calendar-year="previousYear"
          :pititim-price="previousPititimPrice"
        />
      </b-tab>

      <b-tab :title="`${currentYear}`" active>
        <ResponsiblePriceView
          :prices="prices"
          :calendar-year="currentYear"
          :pititim-price="pititimPrice"
        />
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import httpRda from "../../http-rda";

import DataService from "@/services/enrollments.service";
import LoadingList from "@/components/LoadingList.vue";
import DeleteIcon from "@/components/svg/DeleteIcon";
import ResponsiblePriceView from "@/components/ResponsiblePriceView.vue";
import {
  WAITING_LIST_STATUSES,
  waitingListStatusLabel,
} from "@/utils/waitingList";
import "vue-toastification/dist/index.css";

export default {
  name: "Enrollment",
  components: {
    DeleteIcon,
    LoadingList,
    ResponsiblePriceView,
  },
  data() {
    return {
      enrollments: null,
      waitingListStatuses: WAITING_LIST_STATUSES,
      prices: [],
      pititimPrice: null,
      currentYear: new Date().getFullYear(),
      previousPrices: [],
      previousPititimPrice: null,
      previousYear: null,
      enrollmentCalendar: null,
      studentsAnotherResponsible: [],
      hasDefaulter: false,
      actualCalendars: [],
      calendars: [],
    };
  },

  computed: {
    ...mapGetters({
      user: "auth/getAuthData",
    }),

    nextYear() {
      return (this.currentYear + 1).toString();
    },

    previousEnrollmentCalendar() {
      if (!this.enrollmentCalendar) {
        return null;
      }

      return (
        this.calendars.find(
          (calendar) =>
            calendar.current && calendar.id !== this.enrollmentCalendar.id
        ) || null
      );
    },
  },

  methods: {
    waitingListStatusLabel,

    ...mapActions({
      createEnroll: "enrollment/createEnrollment",
    }),

    async getCalendars() {
      this.calendars = await httpRda
        .get("/calendars")
        .then((response) => response.data.calendars);

      this.enrollmentCalendar = this.calendars.find((calendar) => calendar.enrollment);

      await this.defineActualCalendars();
    },

    async defineActualCalendars() {
      const currentYear = await httpRda
        .get("/config/calendars")
        .then((resp) => +resp.data.calendar.designation);

      this.actualCalendars = this.calendars
        .filter(
          ({ designation }) =>
            designation == currentYear || designation == currentYear + 1
        )
        .sort((a, b) => (a.designation > b.designation ? 1 : -1));
    },

    async loadList(responsible_id) {
      this.loading = true;
      await httpRda
        .get(`/responsibles/${responsible_id}/enrollments`)
        .then((resp) => {
          this.enrollments = resp.data.enrollments;

          this.hasDefaulter = this.enrollments.some(
            (enrollment) => enrollment.EnrollmentDefaulters !== null
          );
          this.loading = false;
        });
      this.loading = false;
    },

    async getEnrollmentPrices() {
      await httpRda
        .get("/enrollment-prices")
        .then((resp) => {
          const { current, previous } = resp.data;

          this.prices = current.prices;
          this.pititimPrice = current.pititim_price;
          this.currentYear = current.year;

          if (previous) {
            this.previousPrices = previous.prices;
            this.previousPititimPrice = previous.pititim_price;
            this.previousYear = previous.year;
          } else {
            this.previousPrices = [];
            this.previousPititimPrice = null;
            this.previousYear = null;
          }
        });
    },

    async getAllStudents() {
      try {
        let students;
        await httpRda
          .get(
            `/responsibles/${this.user.responsible_id}/enrollments/allStudents`
          )
          .then((response) => {
            students = response.data;
          });

        if (students.enrollments && students.enrollments.length > 0) {
          const enrollments = students.data.enrollments.filter(
            (x) => x.responsible_id !== this.user.responsible_id
          );

          for (const enrollment of enrollments) {
            const responsibleData = enrollment.EnrollmentResponsibles.filter(
              (c) => c.responsible_id !== this.user.responsible_id
            )[0];

            this.studentsAnotherResponsible.push({
              name: enrollment.EnrollmentStudent.name,
              email: responsibleData.email,
              responsibleName: responsibleData.name,
            });
          }
        }
      } catch (e) {
        // ignore
      }
    },

    async createEnrollment(calendar_id) {
      try {
        this.$swal
          .fire({
            title: "Atenção!",
            text: "Aluno já matriculado? Use “Continuar Matrícula” ou “Rematrícula”.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#68c5b7",
            cancelButtonColor: "#d33",
            confirmButtonText: "Iniciar matrícula para novo aluno",
            cancelButtonText: "Cancelar",
            didOpen: (popup) => {
              const confirmBtn = popup.querySelector('.swal2-confirm');
              const cancelBtn = popup.querySelector('.swal2-cancel');

              if (confirmBtn) {
                confirmBtn.style.minWidth = '350px';
                confirmBtn.style.display = 'inline-block';
              }

              if (cancelBtn) {
                cancelBtn.style.minWidth = '180px';
                cancelBtn.style.display = 'inline-block';
              }
            },
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              const enroll = await this.createEnroll({
                responsible_id: this.user.responsible_id,
                calendar_id,
              });

              const enroll_id = enroll.data.enrollment.id;

              this.$router.push({
                name: "criar-matricula",
                params: { id: enroll_id, step: "dados-do-aluno" },
              });
            }
          });
      } catch (error) {
        this.loading = false;
        this.message =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Por favor, tente novamente mais tarde.",
          footer: `${this.message.error}`,
        });
      }
    },

    getContractor(responsibles) {
      return responsibles.find((res) =>
        res.ResponsibleTypes.some((r) => r.type === "contractor a")
      );
    },

    deleteEnroll(id) {
      this.$swal
        .fire({
          title: "Tem certeza?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await DataService.delete(id);

              this.$swal
                .fire("Excluído!", "Matricula deletada com sucesso.", "success")
                .then((response) => {
                  this.loadList(this.user.responsible_id);
                  return response.data;
                });
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel iniciar!",
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error.response;
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel excluir!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        });
    },

    defineStepByPercentage(percentage = 0) {
      switch (percentage) {
        case 90:
        case 80:
          return "documento";

        case 70:
          return "revisao";

        case 60:
          return "autorizacao";

        case 50:
        case 40:
          return "complementares";

        case 30:
        case 20:
          return "filiacoes";

        case 10:
          return "contratantes";

        default:
          return "dados-do-aluno";
      }
    },

    async rematricularAluno(id, enroll_id, calendar) {
      if (!calendar) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possível iniciar a rematrícula!",
          footer: "Por favor, tente novamente mais tarde.",
        });
        return;
      }
      const enrollmentsStudent = this.enrollments.find(
        (e) => e.EnrollmentStudent?.id === id
      ).EnrollmentStudent.name;
      this.$swal
        .fire({
          title: `Deseja iniciar a rematrícula ${calendar.designation}?`,
          text: `A rematrícula do aluno ${enrollmentsStudent} será iniciada.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await httpRda.patch(`/enrollments/${enroll_id}`, {
              enrollment_id: enroll_id,
              calendar_id: calendar.id,
              finished_at: null,
              signed_at: null,
              is_printed: false,
            });

            await httpRda.patch(`/enrollments/${enroll_id}/students`, {
              is_re_enroll: true,
            });

            await httpRda.patch(`/enrollments/${enroll_id}/setReenroll`);

            this.$router.push({
              name: "rematricula",
              params: {
                id: enroll_id,
                step: "dados-do-aluno",
              },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Rematrícula cancelada!",
              text: "Você pode iniciar a rematrícula a qualquer momento.",
              footer: "",
            });
          }
        });
    },
  },

  beforeCreate() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      this.loading = false;
    } else {
      localStorage.setItem("reloaded", "1");
      this.loading = true;
      location.reload();
    }
  },

  mounted() {
    this.getCalendars();
  },

  created() {
    if (this.user.responsible_id) {
      this.loadList(this.user.responsible_id);
    }
    this.getAllStudents();
  },

  watch: {
    enrollmentCalendar: {
      handler() {
        this.getEnrollmentPrices();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" >
@import "@/assets/css/variables.scss";

.waiting-list-actions {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 6px;
  cursor: default;
}

.waiting-list-tag {
  align-items: center;
  background-color: rgba($orange2, 0.15);
  border-radius: 12px;
  color: darken($orange2, 27%);
  display: inline-flex;
  font-size: 13px;
  font-weight: $bold;
  gap: 6px;
  line-height: 1.3;
  padding: 4px 10px;
  white-space: nowrap;

  &--waiting::before {
    animation: waiting-list-pulse 1.6s ease-out infinite;
    background-color: currentColor;
    border-radius: 50%;
    content: "";
    flex-shrink: 0;
    height: 6px;
    width: 6px;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
}

@keyframes waiting-list-pulse {
  0% {
    box-shadow: 0 0 0 0 currentColor;
  }

  100% {
    box-shadow: 0 0 0 6px transparent;
  }
}

.defautersText {
  text-align: center;
  color: #b23066;
  font-weight: bold;
}

.header-list-teacher {
  color: $grey1;
  margin: 0 0 15px;

  p {
    margin: 0;
  }
}

.btn-rematricula {
  background-color: $blue;
  border: 1px solid $blue;
  border-radius: 5px;
  color: $white;
  display: block;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  max-width: 175px;
  padding: 4px 12px;
  transition: all 0.3s;
  text-align: center;

  &:hover {
    background-color: transparent;
    color: $grey4;
  }
}

.list-teacher {
  background-color: $white;
  border: 1px solid $grey5;
  border-radius: 10px;
  margin-bottom: 15px;
  min-height: 80px;

  &:hover {
    border-color: transparent;
    background-image: linear-gradient($white, $white),
      radial-gradient(circle at top left, $orange, $purple);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }

  p {
    margin: 0;
  }

  .progress-enrollment {
    display: flex;
    align-items: center;

    p {
      font-size: 16px;
      min-width: 50px;
    }

    .progress {
      background-color: $grey5;
      height: 7px;
      max-width: 260px;
      width: 100%;
      padding: 0;

      .progress-bar {
        background-color: $orange;
      }
    }
  }
}

.documents {
  padding-bottom: 95px;

  .box-info {
    border-radius: 10px;
    background-image: linear-gradient($white, $white),
      radial-gradient(circle at top left, $orange, $purple);
    background-origin: border-box;
    background-clip: content-box, border-box;
    border: 1px solid transparent;

    .title {
      background: $gradient1;
      border-radius: 6px 6px 0 0;
      color: $white;
      padding: 21px 40px;
      text-align: center;

      h2 {
        margin: 0;
      }
    }

    .content {
      color: $grey4;
      margin: 0 auto;
      max-width: 1230px;
      padding: 60px 15px;

      ul {
        padding: 0px;
        max-width: 570px;

        li {
          font-size: 18px;
          list-style: none;
          margin-bottom: 5px;

          &:before {
            content: "";
            background: $gradient1;
            border-radius: 30px;
            display: inline-block;
            margin-right: 10px;
            height: 10px;
            width: 10px;
          }
        }
      }

      .obs {
        font-size: 20px;
        line-height: 32px;
      }
    }
  }

  .create-account {
    h2 {
      padding-bottom: 20px;
    }

    form {
      .form-group {
        margin-bottom: 35px;

        legend {
          position: relative;

          &:after {
            content: "*";
            color: $orange;
            font-size: 24px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }

      .required {
        position: relative;

        span {
          color: $orange;
          font-size: 24px;
        }

        color: $grey4;
      }
    }
  }
}

.enrollments-boxes {
  margin-bottom: 40px;
  padding-top: 65px;

  .box {
    background-color: $white;
    border: 1px solid $grey5;
    border-radius: 10px;
    margin-bottom: 40px;
    padding: 32px 40px 60px 40px;

    .tag {
      border-radius: 5px;
      color: $white;
      display: inline-block;
      line-height: 28px;
      margin-bottom: 24px;
      padding: 0 19px;

      &.green {
        background-color: $green1;
      }

      &.orange {
        background-color: $orange;
      }
    }

    h3 {
      margin-bottom: 24px;
    }

    .text {
      margin-bottom: 32px;
    }
  }
}

.contact-form {
  .btn {
    width: 100%;
  }
}

.enrollment-price-tabs {
  .nav-tabs {
    border-bottom: 2px solid #e7e8ec;

    .nav-link {
      color: $grey4;
      font-weight: 600;
      font-size: 16px;
      border: none;
      padding: 12px 24px;
      border-bottom: 3px solid transparent;
      margin-bottom: -2px;
      transition: color 0.2s, border-color 0.2s;

      &:hover {
        color: $purple;
        border-color: transparent;
      }

      &.active {
        color: $purple;
        background-color: transparent;
        border-bottom-color: $purple;
      }
    }
  }
}

</style>
